module.exports = __webpack_public_path__ + "static/img/icon_quarter_en.d635b0d0.jpg";